import _get from 'lodash/get';
import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import css from './book-again-mobile.less';

const BookAgainMobile = ({ completedOrders, onClickBookAgain }) => (
  <div className={css.container}>
    {completedOrders &&
      completedOrders.map(o => (
        <div className={css.item} key={o.deliveryID}>
          <div className={css.senderRecipientContainer}>
            <div>
              <img src={require('public/images/pick-up.svg')} alt="" />
              <div className={css.info}>
                <h2>{_get(o, 'steps[0].contact.name')}</h2>
                <span>{_get(o, 'steps[0].location.address')}</span>
              </div>
            </div>
            <div>
              <img src={require('public/images/drop-off.svg')} alt="" />
              <div className={css.info}>
                <h2>{_get(o, 'steps[1].contact.name')}</h2>
                <span>{_get(o, 'steps[1].location.address')}</span>
              </div>
            </div>
          </div>
          <div className={css.bookAgain}>
            <button onClick={onClickBookAgain(o)}>
              {I18n.t('v2.orderTable.action.bookAgain')}
            </button>
          </div>
        </div>
      ))}
  </div>
);

BookAgainMobile.propTypes = {
  completedOrders: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClickBookAgain: PropTypes.func.isRequired,
};

export default BookAgainMobile;
